import { Helmet } from 'react-helmet-async';

import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// @mui
import { Stack, Paper, Button, Container, Typography, Grid, CircularProgress, Box } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';

import { GetFootfall } from 'src/components/services/httpServices';

import { AuthContext } from '../Context/Auth/auth.context';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function FootFallDetails() {
  let { id } = useParams();
  const navigate = useNavigate();

  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');
  const [footFall, setFootFall] = useState({});
  let {
    authState: { deptId },
  } = useContext(AuthContext);
  const fetch = async (event) => {
    const footfall = await GetFootfall(id);
    setFootFall(footfall);
    setLoading(false);
  };
  useEffect(() => {
    fetch();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  //console.log('company', company);
  return (
    <>
      <Helmet>
        <title> Foot Fall | Immigration System </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          {deptId == '6' ? (
            <Typography variant="h4" gutterBottom>
              Recruitment Enquiries
            </Typography>
          ) : deptId == '7' ? (
            <Typography variant="h4" gutterBottom>
              Marketing Enquiries
            </Typography>
          ) : deptId == '1' ? (
            <Typography variant="h4" gutterBottom>
              Sales Enquiries
            </Typography>
          ) : (
            <Typography variant="h4" gutterBottom>
              Footfall/Walkin
            </Typography>
          )}

          <Stack direction="row" spacing={2}>
            <Button
              onClick={() => {
                navigate(-1);
              }}
              variant="contained"
            >
              Back
            </Button>
            <Button type="submit" variant="contained">
              Save
            </Button>
          </Stack>
        </Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Box
            p={4}
            component={Paper}
            boxShadow={3}
            sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
          >
            <Grid container spacing={3}>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  First Name :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {footFall?.firstName}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Last Name :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {footFall?.lastName}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Client Type :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {footFall?.clientType}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Passport No :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {footFall?.passportNo}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Address :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {footFall?.address}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Phone Number :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {footFall?.phoneNumber}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Email Address :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {footFall?.emailAddress}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  City :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {footFall?.city}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Country of Origin :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {footFall?.countryOfOrigin}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Walkin Date :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {footFall?.walkInDatetime?.split('T')[0]}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Walkin Time :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {footFall?.walkInDatetime?.split('T')[1]}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Purpose of Visit :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {footFall?.purposeOfVisit}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Meeting With :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {footFall?.meetingWith}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )}
      </Container>
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
